import styled, { css, getSectionBackgroundStyle, mediaQuery, theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import usageTracker from '../../../utils/usageTracker';
import ACInstructorCard from 'academy-common-lib/components/card/ACInstructorCard';
import { H2 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ACHorizontalScrollContainer from 'academy-common-lib/components/container/ACHorizontalScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProfessorSection = styled.section.withConfig({
  displayName: "PublicPageProfessorsSection__ProfessorSection",
  componentId: "bijk2a-0"
})(["padding:32px 0 24px 0;", ""], getSectionBackgroundStyle(theme.colors.GYPSUM));
const ScrollableContainer = styled(ACHorizontalScrollContainer).withConfig({
  displayName: "PublicPageProfessorsSection__ScrollableContainer",
  componentId: "bijk2a-1"
})(["display:flex;gap:32px;", ""], mediaQuery('mobile', css(["flex-direction:column;gap:0;"])));
const PublicPageProfessorsSection = ({
  professors,
  contentType,
  lessonId,
  trackId
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const trackProfessorClick = (professorId, organisation, organisationUrl) => () => {
    usageTracker.track('interaction', {
      action: 'professor-organisation-click',
      contentType,
      appearsIn: 'public-landing-page',
      organisation,
      organisationUrl,
      professorId,
      lessonId,
      trackId
    });
  };
  return /*#__PURE__*/_jsxs(ProfessorSection, {
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.instructors.heading"
      })
    }), /*#__PURE__*/_jsx(ScrollableContainer, {
      children: professors.map(professor => /*#__PURE__*/_jsx(ACInstructorCard, {
        description: professor.description,
        imageUrl: professor.professorImage,
        jobTitle: professor.jobTitle,
        name: professor.name,
        onClick: trackProfessorClick(professor.id.toString(), professor.organisation, professor.organisationUrl),
        organisationName: professor.organisation,
        organisationUrl: professor.organisationUrl,
        style: {
          minWidth: !isMobile && professors.length && 'calc(min(850px, 100vw) * 0.8)' || undefined
        }
      }, professor.id))
    })]
  });
};
export default PublicPageProfessorsSection;